import stepTypes from './types';
import Location from './Location';
import Time from './Time';
import Summary from './Summary';
import PersonalData from './PersonalData';
import Reschedule from './Reschedule';
import WaitlistData from './WaitlistData';

const stepsList = {
  [stepTypes.location]: Location,
  [stepTypes.time]: Time,
  [stepTypes.summary]: Summary,
  [stepTypes.personalData]: PersonalData,
  [stepTypes.reschedule]: Reschedule,
  [stepTypes.waitlist]: WaitlistData,
};

export default stepsList;
